import React, { useState, useEffect } from 'react';

import appService from '../../service/app.service';
import { ButtonUI, DialogUI, FormLabelUI, SelectUI } from '../Interface';
import useParam from '../../context/ParamContext';

const RoleModify = (props) => {
  const { params } = useParam();
  const [permission, setPermission] = useState(props.hasPermission);
  const [canEdit, setCanEdit] = useState(true);
  const [canCopy, setCanCopy] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    setPermission(props.hasPermission);
    const findedPerm = props.roleSubMenuPermissions.find((f) => f.subMenuId === props.selectedSubMenu);
    const selectedRolePermission = findedPerm?.roleSubmenuPermission.find(
      (permission) => permission.roleId === props.roleId
    );
    const canEdit = selectedRolePermission?.canEdit ?? true;

    setCanEdit(canEdit);

    if (!canEdit) {
      setCanCopy(false);
      setCanDelete(false);
    } else {
      setCanCopy(findedPerm?.roleSubmenuPermission[0]?.canCopy ?? false);
      setCanDelete(findedPerm?.roleSubmenuPermission[0]?.canDelete ?? false);
    }
  }, [props]);

  useEffect(() => {
    if (!canEdit) {
      setCanCopy(false);
      setCanDelete(false);
    }
  }, [canEdit]);

  const handleChangeRole = async () => {
    appService
      .updateSubMenuPermission(props.roleId, props.selectedSubMenu, permission, canEdit, canCopy, canDelete)
      .then(() => {
        const updatedSubMenuList = props.roleSubMenuPermissions.map((permission) =>
          permission.subMenuId === props.selectedSubMenu ? { ...permission, hasPermission: permission } : permission
        );
        props.setRoleSubMenuPermissions(updatedSubMenuList);
        props.setRefreshPage(!props.refreshPage);
        props.onHide();
      })
      .finally(() => {});
  };

  const options = [
    { value: true, label: 'Jogosult' },
    { value: false, label: 'Nem jogosult' },
  ];

  return (
    <DialogUI open={props.show} headerContent={'Jogosultság módosítás'} fullWidth>
      <div className="flex justify-center flex-wrap">
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={permission ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setPermission(value);
            }}
            option={options}
            label={<FormLabelUI text="Jogosultság beállítása" />}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canEdit ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanEdit(value);
            }}
            option={options}
            label="Szerkesztheti"
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canCopy ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanCopy(value);
            }}
            option={options}
            label={<FormLabelUI text="Másolhat" />}
            disabled={!canEdit || !params.ROLE_COPY_DELETE_NOT_DISABLED?.includes(props.selectedSubMenu)}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canDelete ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanDelete(value);
            }}
            option={options}
            label={<FormLabelUI text="Törölhet" />}
            disabled={!canEdit || !params.ROLE_COPY_DELETE_NOT_DISABLED?.includes(props.selectedSubMenu)}
          />
        </div>
      </div>
      <div className="px-4 mt-8 flex justify-center gap-3">
        <ButtonUI text="Hozzáadás" type="button" className="bg-success" onClick={handleChangeRole}>
          Mentés
        </ButtonUI>

        <ButtonUI text="Mégse" type="button" onClick={props.onHide} color="blue-gray" variant="gradient"></ButtonUI>
      </div>
    </DialogUI>
  );
};

export default RoleModify;
